import React, { useState } from "react";

import { ICellRendererParams } from "@ag-grid-community/core";

import HasNote from "@mapmycustomers/shared/types/base/HasNote";
import useDynamicCallback from "@mapmycustomers/shared/util/hook/useDynamicCallback";

import NoteEditor from "./components/NoteEditor";

const EditableNoteCellRenderer: React.FC<ICellRendererParams> = ({ context, data, node }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleSave = useDynamicCallback((payload: { entity: HasNote; onSuccess?: () => void }) => {
    setLoading(true);
    try {
      context.onSaveNote({
        ...payload,
        onFailure: () => {
          setLoading(false);
        },
        onSuccess: (entity: HasNote) => {
          setLoading(false);
          node.updateData(entity);
          payload.onSuccess?.();
        },
      });
    } catch {
      setLoading(false);
    }
  });

  return (
    <NoteEditor
      entity={data as HasNote}
      loading={loading}
      onSave={context?.onSaveNote ? handleSave : undefined}
    />
  );
};

export default EditableNoteCellRenderer;
